import React, { useState } from "react";
import { Box, TextField, Button, Typography, Paper } from "@mui/material";

export default function SectionForm({
  section = null,
  onSave,
  onCancel,
  loading = false,
  error = null,
  onClearError = null
}) {
  const [name, setName] = useState(section?.name || "");
  const [weight, setWeight] = useState(section?.rubricScoreWeight?.toString() || "");
  const [validationError, setValidationError] = useState("");

  const isEditing = Boolean(section);

  const handleSubmit = (e) => {
    e.preventDefault();
    setValidationError("");

    if (!name.trim()) {
      setValidationError("Section name is required");
      return;
    }

    if (weight && isNaN(Number(weight))) {
      setValidationError("Weight must be a valid number");
      return;
    }

    onSave({
      name: name.trim(),
      rubricScoreWeight: weight ? Number(weight) : null
    });
  };

  return (
    <Paper
      component="form"
      onSubmit={handleSubmit}
      sx={{
        p: 3,
        mb: 2,
        border: 1,
        borderColor: "grey.300"
      }}
    >
      <Typography variant="h6" sx={{ mb: 2 }}>
        {isEditing ? "Edit Section" : "Add Section"}
      </Typography>

      <TextField
        label="Section Name"
        fullWidth
        value={name}
        onChange={(e) => {
          setName(e.target.value);
          if (validationError) {
            setValidationError("");
          }
          if (error && onClearError) {
            onClearError();
          }
        }}
        disabled={loading}
        error={!!validationError || !!error}
        helperText={validationError || error?.message}
        sx={{ mb: 2 }}
      />

      <TextField
        label="Weight"
        type="number"
        fullWidth
        value={weight}
        onChange={(e) => setWeight(e.target.value)}
        disabled={loading}
        helperText="Section weight for overall rating score (default is .33)"
        sx={{ mb: 3 }}
      />

      <Box sx={{ display: "flex", gap: 1 }}>
        <Button
          type="submit"
          variant="contained"
          disabled={loading}
        >
          {loading ? "Saving..." : isEditing ? "Save" : "Save Section"}
        </Button>
        <Button
          type="button"
          variant="outlined"
          onClick={onCancel}
          disabled={loading}
        >
          Cancel
        </Button>
      </Box>
    </Paper>
  );
}
